import React from 'react';

/*
    Note: if you update these breakpoints, please make sure to update the mobile
    breakpoints in the GigCardCarouselWrapper/RecentlyViewedGigs styles.scss file as well
*/

export const GIG_GRID_XLRG = 1240;
export const GIG_GRID_LRG = 899;
export const GIG_GRID_MED = 750;
export const GIG_GRID_SML = 530;

function CustomArrow(props) {
    const {
        className,
        onClick
    } = props;

    return (
        <button className={className} onClick={onClick}/>
    );
}

export const createSliderSettings = (baseNum, breakpoints, isTouch, collectImpressionable) => {

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: !isTouch,
        nextArrow: <CustomArrow/>,
        prevArrow: <CustomArrow/>,
        centerMode: false,
        slidesToShow: baseNum,
        slidesToScroll: baseNum,
        responsive: [],
        afterChange: () => {
            collectImpressionable();
        }
    };

    breakpoints.forEach((bp) => {
        const { breakpoint, slides } = bp;
        sliderSettings.responsive.push({
            breakpoint,
            settings: {
                slidesToShow: slides,
                slidesToScroll: slides
            }
        });
    });

    return (
        sliderSettings
    );
};